import { useEffect, useState } from 'react'
import jwtDecode from 'jwt-decode'
import { useDispatch } from 'react-redux'
import { logout } from 'redux/thunks/api'
import { TOKEN } from 'util/session-constants'
import { getFromStorage } from 'util/storage'
import { toast } from 'util/toast'

export default () => {
  const dispatch = useDispatch()
  const handleLogout = async () => dispatch(logout())
  const [timeLeft, setTimeLeft] = useState(1)
  const now = Date.now()
  const token = getFromStorage(TOKEN)

  const handleSessionEnd = async () => {
    await handleLogout()
    toast.error(
      <p className="m-1.5 leading-4">
        Your MFA session has expired. Please re-enter your login credentials to try again.
      </p>,
    )
  }

  useEffect(() => {
    if (token) {
      const {
        exp,
        user: { type },
      }: { exp: number; user: { type: string } } = jwtDecode(token)
      if (type === 'mfa' && !!exp) {
        setTimeLeft(exp * 1000 - now) // ((exp * 1000) - 5) for testing
      }
    }
    // DO NOT add now to dependency array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  useEffect(() => {
    if (!timeLeft) return
    const interval = setInterval(() => {
      setTimeLeft(timeLeft - 1)
    }, 1000)
    return () => {
      clearInterval(interval)
    }
  }, [timeLeft])

  return {
    /*
      ending the session from the component allows us to throw toast and avoid page refresh
    */
    timeLeft,
    handleSessionEnd,
  }
}
